import { makeStyles } from '@material-ui/core/styles'

export const libraryQuickSearchStyles = makeStyles((theme) => ({
  quickSearchImgContainer: {
    margin: 5,
    padding: '2px 8px 0px 8px',
    backgroundColor: theme.palette.base.white,
  },
  quickSearchImg: {
    height: 35,
    width: 'auto',
  },
  searchBar: {
    backgroundColor: theme.palette.backgroundColor.ternary,
  },
}))

export default libraryQuickSearchStyles
